import React from 'react';
import { motion } from 'framer-motion';
import { SacredGeometry } from './SacredGeometry';
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  backgroundImage
}: PageHeaderProps) {
  const hasImage = Boolean(backgroundImage);
  return <section className={`relative w-full py-24 md:py-32 px-6 overflow-hidden ${hasImage ? 'bg-teal-dark bg-cover bg-center md:bg-right' : 'bg-teal text-center'}`} style={hasImage ? {
    backgroundImage: `url('${backgroundImage}')`,
    backgroundRepeat: 'no-repeat'
  } : undefined} data-id="element-302">
      {hasImage ? <>
          {/* Mobile: full solid dark overlay for readability over centered image */}
          <div className="absolute inset-0 bg-teal-dark/70 md:hidden pointer-events-none" data-id="element-303" />
          {/* Desktop: gradient overlay fading from dark left to transparent right */}
          <div className="absolute inset-0 hidden md:block pointer-events-none" style={{
        background: 'linear-gradient(to right, rgba(8,32,31,0.85) 0%, rgba(8,32,31,0.6) 35%, rgba(8,32,31,0.2) 65%, rgba(8,32,31,0) 100%)'
      }} data-id="element-304" />
        </> : <>
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] pointer-events-none opacity-50" data-id="element-305">
            <SacredGeometry color="#FFFFFF" data-id="element-306" />
          </div>
          <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] pointer-events-none opacity-50" data-id="element-307">
            <SacredGeometry color="#FFFFFF" data-id="element-308" />
          </div>
        </>}

      <div className={`relative max-w-7xl mx-auto z-10 ${hasImage ? 'grid grid-cols-1 lg:grid-cols-2 gap-12 items-center' : ''}`} data-id="element-309">
        <div className={hasImage ? 'text-center lg:text-left' : ''} data-id="element-310">
          {eyebrow && <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="font-serif italic text-gold uppercase tracking-[0.25em] text-xs md:text-sm mb-6" data-id="element-311">
              {eyebrow}
            </motion.p>}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-serif text-white text-4xl md:text-5xl lg:text-6xl leading-tight drop-shadow-md" data-id="element-312">
            {title}
          </motion.h1>
          {subtitle && <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className={`font-serif italic text-white/85 text-lg md:text-xl mt-6 leading-relaxed ${hasImage ? 'max-w-xl mx-auto lg:mx-0' : 'max-w-2xl mx-auto'}`} data-id="element-313">
              {subtitle}
            </motion.p>}
        </div>

        {hasImage && <div className="hidden lg:block" aria-hidden="true" data-id="element-314" />}
      </div>
    </section>;
}